module.exports = __webpack_public_path__ + "img/you-plus-wechat-qrcode.fcdc0ac6.jpg";